import Settings from 'core/settings'

export const useAssetUrl = (path) => {
  const host = Settings.asset_host || window.location.host
  return `${window.location.protocol}//${host}/assets/${path}`
}
